import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import BrandHeader from './components/BrandHeader';
import LoginTabs from './components/LoginTabs';
import RoleIndicator from './components/RoleIndicator';
import LoginForm from './components/LoginForm';
import StudentCodeLogin from './components/StudentCodeLogin';

const LoginPage = () => {
  const [activeTab, setActiveTab] = useState('email');
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async (userRole, userData = null) => {
    setIsLoading(true);
    
    // Simulate authentication process
    await new Promise(resolve => setTimeout(resolve, 1500));
    
    // Store user session (in real app, this would be handled by auth service)
    const sessionData = {
      role: userRole,
      loginTime: new Date()?.toISOString(),
      ...(userData && { userData })
    };
    
    localStorage.setItem('mydojo_session', JSON.stringify(sessionData));
    
    setIsLoading(false);
  };

  const handleTabChange = (tabId) => {
    if (!isLoading) {
      setActiveTab(tabId);
    }
  };

  return (
    <>
      <Helmet>
        <title>Login - MyDojo Academy Management</title>
        <meta name="description" content="Secure login for MyDojo academy management system. Access for owners, staff, coaches, and students." />
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
      </Helmet>
      <div className="min-h-screen bg-background flex items-center justify-center p-4 sm:p-6 md:p-8">
        {/* Background Pattern */}
        <div className="absolute inset-0 bg-muted"></div>
        
        {/* Login Container - Mobile optimized */}
        <div className="relative w-full max-w-md">
          {/* Main Login Card - Responsive padding */}
          <div className="bg-card rounded-2xl p-6 sm:p-8 md:p-10 border border-border">
            {/* Brand Header */}
            <BrandHeader />
            
            {/* Login Tabs - Touch-friendly */}
            <LoginTabs 
              activeTab={activeTab} 
              onTabChange={handleTabChange} 
            />
            
            {/* Role Indicator */}
            <RoleIndicator activeTab={activeTab} />
            
            {/* Login Forms - Mobile spacing */}
            <div className="space-y-4 sm:space-y-6">
              {activeTab === 'email' ? (
                <LoginForm 
                  onLogin={handleLogin}
                  propLoading={isLoading}
                />
              ) : (
                <StudentCodeLogin 
                  onLogin={handleLogin}
                  isLoading={isLoading}
                />
              )}
            </div>
          </div>
          
          {/* Footer - Responsive text */}
          <div className="text-center mt-4 sm:mt-6">
            <p className="text-xs sm:text-sm text-muted-foreground">
              © {new Date()?.getFullYear()} MyDojo. A product of Sinistro Photo Film & Design Inc.
            </p>
            <p className="text-xs text-muted-foreground mt-1">
              All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;